import Vue from 'vue'
import Vuex from 'vuex'
import { _config } from "../common/js/constant"
import * as dd from "dingtalk-jsapi"; //钉钉
import { requestLogin, requestPhone, getInfo, requestButtomAuth } from '@/api'
import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'
import { Toast } from 'vant';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: getToken(),
        user: getUser(),
        keepAlive: [],
        buttonAuth: [],
        isChange: false,
        upload_qiniu_addr: 'http://img.room1000.com/',
        qiniuUpload: 'https://up.qbox.me/',
        idTypeList: ["身份证", "港澳通行证", "护照", "驾照", "其它", "社会信用代码", "台湾通行证", '营业执照'],
        destineList: ["下定", "取消下定", "已完成"], //预订单状态
        statusReserveList: ["未下定", "已下定", "部分下定"], //下定状态
        cancelStatusList: ["审核通过", "驳回", "提交"], //取消下定审批状态
        payList: ["未支付", "部分支付", "已支付"], //支付状态
        payTypeList: ["支付宝", "微信", "银行卡（储蓄卡）", "信用卡"],
        caStatusList: ['未签署', '签署中', '已签署', '不签署'],
        syncFgjNjList: ['待推送', '已网签', '已备案', '已解约'],
        contractList: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "已失效",
            "重签作废",
            "保存作废",
            "退租中",
            "打回作废"
        ], //合约状态
        CAStatusList: ["未认证", "认证中", "已认证"], //ca状态
        contractTypeList: ['新签', '续签', '换房', '转租'], //合约类型
        customerList: ["电话咨询", "在线咨询", "预约带看", "完成带看", "取消下定", "下定", "签约成功", "无意向", "待跟进", "退租", "创建用户", "抢单", "转让", "获取客户", "派单", "回访", "接单"], //租客状态 / 操作状态
        contactList: [
            "夫妻",
            "父母",
            "子女",
            "兄弟",
            "姐妹",
            "亲戚",
            "朋友",
            "同事",
            "其它"
        ], //紧急联系人关系
        approvalStatusList: ["已同意", "不同意"], //审批结果
        quitTypeList: [
            "到期退租",
            "租客违约退",
            "正常提前退租",
            "公司违约退",
            "房东违约退",
            "协商违约退",
            "续约退租",
            "换房退租",
            "转租退租"
        ], //退租类型
        returnOrderStatus: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "作废"
        ], //退租单状态
        towardList: [{
                label: "东",
                value: "E"
            },
            {
                label: "南",
                value: "S"
            },
            {
                label: "西",
                value: "W"
            },
            {
                label: "北",
                value: "N"
            },
        ], //房间朝向
        houseStatusList: ["待签约", "签约中", "待开工", "施工中", "待保洁", "空置", "部分空置", "满住", "退房中", "已退房"], //房源状态
        roomStatusList: ["待签约", "签约中", "待开工", "施工中", "待保洁", "空置", "", "已入住", "退房中", "已退房"], //房间状态
        applyTypeList: ["换房", "转租", "续约", "退租"], //申请类型
        applyStatusList: ["待处理", "处理中", "已处理", "撤销"], //申请状态
        settlementStatusList: ["钱包已结算", "退租已结算", "作废"], //结算状态
        pContractStatusList: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "退房中",
            "已失效",
            "作废"
        ], //收房合约状态
        pReturntStatusList: [
            "保存",
            "提交",
            "打回",
            "审核通过",
            "作废"
        ], //退房单状态
        pQuitTypeList: [
            "到期退租",
            "租客违约退",
            "正常提前退租",
            "公司违约退",
            "房东违约退",
            "协商违约退",
            "续约退房"
        ], //退房单类型
        buildingTypeList: ["栋", "幢", "号", "座"], //楼栋单位
        remodelStatusList: ["保存", "提交", "打回", "审核通过"], //装修单状态
        propertyFileTypeList: [
            "不动产权证明书",
            "房屋所有权证",
            "商品房买卖合同",
            "其它"
        ], //产权文件类型
        equityTypeList: ['私有房产', '单位房产', '公房', '涉外房产', '其它房产'],
        equityIdTypeList: ['身份证', '营业执照'], // 产权人证件类型
        purposeList: ['住宅', '公寓', '集体宿舍', '别墅', '工业', '商业', '经营', '办公', '商住', '酒店式公寓', '综合', '其它'],
        rentPurposeList: ['居住', '办公', '商住', '工业', '其它'],
        workOrderTypeList: [{ label: "维修工单", value: "WX" }, { label: "投诉工单", value: "TS" }, { label: "保洁工单", value: "BJ" }, { label: "咨询工单", value: "ZX" }, { label: "清洗工单", value: "QX" }, { label: "搬运工单", value: "BY" }],
        workOrderStatusList: ["待指派", "待接单", "待处理", "处理中", "已完成", "已关闭"], //工单状态
        workOrderLogList: ["创建工单", "派单", "转单", "接单", "开工", "完成", "关闭", "添加备注"],
        workOrderRoleList: ["管家", "租客", "业主", "其他"],
        belongTypeList: ["我负责的", "我创建的", "我协同的"],
        createDateSortTypeList: ['创建时间由远到近', '创建时间由近到远'],
        lockTypeList: ["在线密码", "激活密码", "临时密码"],
        lockStatusList: ["正常", "冻结", "删除"],
        lockResultList: ["已下发", "下发成功", "下发失败"],
        lockOpList: ["添加", "修改", "删除", "冻结", "解冻"],
        fssTenantTypeList: ['包租', '托管', '托管+'],
        deviceTypeIcon: ['iconzhinengmensuo', 'icondianbiao', 'iconshuibiao', 'iconreshui', 'iconwangguan'],
        deviceType: ['门锁', '电表', '冷水表', '热水表', '网关', '水表网关'],
        svgSuccessList: ['icon-doorlock', 'icon-ammeter', 'icon-cold-w-meter', 'icon-hot-w-meter', 'icon-gateway'],
        svgFailList: ['icon-lock-offline', 'icon-ammeter-offline', 'icon-cold-w-meter-offline', 'icon-hot-w-meter-offline', 'icon-gateway-offline'],
        deviceStatus: ['待绑定', '已绑定', '无效'],
        operationTypeList: ['在线密码', '激活密码', '临时密码', '合闸', '关闸'],
        operationResult: ['已下发', '成功', '失败'],
        opListStatus: ["添加", "修改", "删除"],
        onlineList: ['在线', '离线', '升级中', '休眠']

    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_CHANGE: (state, change) => {
            state.isChange = change
        },
        SET_USER: (state, user) => {
            state.user = user
        },
        SET_KEEP_ALIVE: (state, keepAlive) => {
            state.keepAlive = keepAlive
        },
        REMOVEONE_KEEP_ALIVE: (state, keepAlive) => {
            let alive = []
            state.keepAlive
            let tmp = state.keepAlive.concat(keepAlive);
            let o = {};
            for (let i = 0; i < tmp.length; i++) {
                (tmp[i] in o) ? o[tmp[i]]++: o[tmp[i]] = 1;
            }
            for (let key in o) {
                if (o[key] == 1) {
                    alive.push(key);
                }
            }
            state.keepAlive = alive
        },
        SET_BUTTON: (state, buttonAuth) => {
            state.buttonAuth = buttonAuth
        }
    },
    actions: {
        // user login
        getPhone({ commit, dispatch }, userInfo) {
            return new Promise((resolve, reject) => {
                if (dd.env.platform !== "notInDingTalk") {
                    dd.ready(function() {
                        dd.runtime.permission.requestAuthCode({
                            corpId: _config.corpId, // 企业id
                            onSuccess: function(info) {
                                // alert(JSON.stringify(info))
                                requestPhone({ code: info.code }).then(response => {
                                    // alert(JSON.stringify(response))
                                    let param = { phone: response.data, source: 'crm' }
                                    dispatch('getToken', param).then(res => {
                                        resolve(res.data)
                                    }).catch(err => [
                                        reject(err)
                                    ])
                                }).catch(err => {
                                    // alert(err)
                                    reject(err)
                                })
                            },
                            onFail: function(err) {
                                // alert(JSON.stringify(err))
                                reject(err)
                            }
                        });
                    })
                } else {
                    Toast("请用钉钉浏览器打开")
                }
                // let param = { phone: '18694995414', source: 'crm' }
                // dispatch('getToken', param).then(res => {
                //     resolve(res.data)
                // }).catch(err => [
                //     reject(err)
                // ])
            })
        },
        // get token
        getToken({ commit, dispatch }, param) {
            return new Promise((resolve, reject) => {
                console.log(param)
                requestLogin(param).then(response => {
                    // alert(JSON.stringify(response))
                    commit('SET_TOKEN', response.data)
                    setToken(response.data)
                    requestButtomAuth({ test: 1 }).then(res => {
                        commit('SET_BUTTON', res.data || [])
                    })
                    dispatch('getUserInfo').then(res => {
                        resolve(response)
                    }).catch(err => [
                        reject(err)
                    ])
                }).catch(err => {
                    reject(err)
                })
            })
        },

        // get user info
        getUserInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo().then(response => {
                    if (!response.data) {
                        reject('请登录')
                    }
                    const user = response.data
                    commit('SET_USER', user)
                    setUser(user)
                        // commit('SET_INTRODUCTION', introduction)
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // reset user
        resetAll({ commit, dispatch }, token) {
            return new Promise(resolve => {
                commit('SET_TOKEN', token)
                setToken(token)
                commit('SET_CHANGE', true)
                resolve()
                    // dispatch('getUserInfo').then(res => {
                    //     resolve()
                    // })
            })
        },
    },
    modules: {}
})